import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-3 w-3 inline -mt-0.5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
  })
], -1)
const _hoisted_2 = ["value"]

import { ref } from 'vue';
import { useRouter } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'CopyArticleLink',
  setup(__props) {

const input = ref<HTMLInputElement | null>(null);
const recentlyClicked = ref(false);
const router = useRouter();
const route = ref(router.currentRoute.value.fullPath);

function clicked() {
  if (input.value) {
    input.value.setAttribute('type', 'text');
    input.value.select();
    document.execCommand('copy');
    input.value.blur(); // Prevent keyboard from popping up on Android
    input.value.setAttribute('type', 'hidden');

    recentlyClicked.value = true;
    setTimeout(() => { recentlyClicked.value = false; }, 2000);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("span", {
      onClick: clicked,
      class: "cursor-pointer block text-sm no-underline text-blue-600 hover:text-blue-800 w-fit mb-6"
    }, [
      _createTextVNode(_toDisplayString(recentlyClicked.value ? 'Link copied' : 'Copy article link') + " ", 1),
      _hoisted_1
    ]),
    _createElementVNode("input", {
      type: "hidden",
      value: `https://www.nslookup.io${route.value}`,
      ref_key: "input",
      ref: input
    }, null, 8, _hoisted_2)
  ], 64))
}
}

})